<div class="well">
	<h2>Affiliations <button class="icon--add btn--default" type="button" (click)="addAffiliation()" *ngIf="canEdit">Add Affiliation</button><button class="icon--history btn--default" type="button" (click)="showHistory(customerNumber)">View History</button></h2>
	<p-tree [value]="rootNode" layout="horizontal" selectionMode="single">
		<ng-template let-open pTemplate="togglericon">
			<span *ngIf="open" class="pi pi-minus"></span>
			<span *ngIf="!open" class="pi pi-plus"></span>
		</ng-template>
		<ng-template let-node pTemplate="parent">
			{{node.label}}
			<a class="icon--edit" title="Edit Affiliation" href="javascript:void(0)" *ngIf="canEdit" (click)="editAffiliation(node)"></a>
		</ng-template>
		<ng-template let-node pTemplate="child">
			<div>{{node.data.name}}</div>
			<div>{{node.data.description}}</div>
		</ng-template>
	</p-tree>
</div>